import React, { useState, useEffect } from 'react';
import { FaUserMd, FaStethoscope } from 'react-icons/fa';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';
import { getDoctors, getFileUrl } from '../services/api';

const Specialists = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoctors()
      .then(res => setDoctors(res.data?.data || []))
      .catch(() => setDoctors([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-wrapper">
      <Header title="Meet Our Specialists" />
      <Sidebar />
      <main className="page-content">
        <div className="page-header">
          <div>
            <h1><FaStethoscope style={{ color: 'var(--primary)', marginRight: 8 }} />Meet Our Specialists</h1>
            <p>{doctors.length} doctor{doctors.length === 1 ? '' : 's'} available</p>
          </div>
        </div>

        {loading ? (
          <div className="loading-container"><div className="spinner" /></div>
        ) : doctors.length === 0 ? (
          <div className="empty-state"><FaUserMd className="empty-state-icon" /><h3>No specialists found</h3><p>Check back soon</p></div>
        ) : (
          <div className="specialists-grid">
            {doctors.map(doc => (
              <div key={doc.id} className="specialist-card">
                <div className="specialist-photo">
                  {doc.profileImage ? (
                    <img src={getFileUrl(doc.profileImage)} alt={doc.name} />
                  ) : (
                    <FaUserMd />
                  )}
                </div>
                <div className="specialist-info">
                  <div className="specialist-name">Dr. {doc.name}</div>
                  <div className="specialist-designation">{doc.degree || doc.specialization || 'Specialist'}</div>
                  {doc.degree && doc.specialization && (
                    <div className="specialist-sub">{doc.specialization}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <BottomNav />

      <style>{`
        .specialists-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px; }
        .specialist-card { background: #fbfdff; border-radius: 18px; overflow: hidden; }
        [data-theme="dark"] .specialist-card { background: #1e293b; }
        .specialist-photo {
          width: 100%; aspect-ratio: 1 / 1; background: #d3dce3;
          display: flex; align-items: center; justify-content: center;
          overflow: hidden; font-size: 40px; color: var(--primary);
        }
        [data-theme="dark"] .specialist-photo { background: #263449; }
        .specialist-photo img { width: 100%; height: 100%; object-fit: cover; }
        .specialist-info { padding: 12px 14px 16px; background: #fbfdff; }
        [data-theme="dark"] .specialist-info { background: #1e293b; }
        .specialist-name { font-size: 14px; font-weight: 700; color: var(--text-dark); }
        .specialist-designation { font-size: 12px; color: var(--text-light); margin-top: 2px; }
        .specialist-sub { font-size: 11px; color: var(--text-light); margin-top: 1px; }
        @media (min-width: 768px) { .specialists-grid { grid-template-columns: repeat(3, 1fr); gap: 18px; } }
        @media (min-width: 1200px) { .specialists-grid { grid-template-columns: repeat(4, 1fr); gap: 20px; } }
      `}</style>
    </div>
  );
};

export default Specialists;
